// @flow
import React from 'react';
import styled, { keyframes, css } from 'styled-components';
import { colors } from 'bench-style-constants';

const animation = keyframes`
  0%, 40%, 100% {
    transform: scaleY(0.4);
  }  20% {
    transform: scaleY(1.0);
  }
`;
const animationRule = css`
  ${animation} 1.2s ease-in-out ${({ delay }) => delay} infinite;
`;

const Container = styled.div`
  width: 40px;
  height: 40px;
  display: inline-block;
`;

const Bar = styled.div`
  background-color: ${({ color }) => color};
  height: 100%;
  width: 6px;
  display: inline-block;
  animation: ${animationRule};
  border-radius: 3px;
  margin: 0 2px;
`;

type SpinnerProps = {
  active?: boolean,
};

const Spinner = ({ active }: SpinnerProps) => {
  if (!active) {
    return null;
  }

  return (
    <Container aria-label="Loading">
      <Bar color={colors.water} delay="-1s" />
      <Bar color={colors.branch} delay="-0.9s" />
      <Bar color={colors.gold} delay="-0.8s" />
      <Bar color={colors.copper} delay="-0.7s" />
    </Container>
  );
};

Spinner.defaultProps = { active: true };

export default Spinner;
